// extracted by mini-css-extract-plugin
export default {"content":"TextContent_content__tXbBz","about":"TextContent_about__hGvH5","choice":"TextContent_choice__XYP85"};